import { ArrayPath } from './ArrayPath'
import { getArrayPath } from './getArrayPath'

/**
 * Uses a string or array path to delete a property inside an object or array.
 * Returns a shallow clone of the object and only affects properties along
 * the supplied path
 * @param obj The root object
 * @param path The path of the item to be deleted
 * @returns Shallow copy of obj
 */
export const deleteByPath = (
  obj: Record<string, any> | Array<any>,
  path: string | ArrayPath
) => {
  path =
    typeof path === 'string'
      ? getArrayPath(path)
      : path == undefined
      ? []
      : path

  if (!obj || typeof obj !== 'object' || path.length === 0) {
    return obj
  }

  const next =
    Array.isArray(obj) && typeof path[0] === 'number'
      ? Object.is(path[0], -0)
        ? obj.length - 1
        : path[0] < 0
        ? obj.length + path[0]
        : path[0]
      : path[0]

  if (!(next in obj)) {
    return obj
  }

  return path.length === 1
    ? Array.isArray(obj)
      ? obj.filter((_, i) => i !== next)
      : Object.fromEntries(Object.entries(obj).filter(([key]) => key !== next))
    : Array.isArray(obj)
    ? obj.map((x, i) =>
        i === next ? deleteByPath(obj[next], path.slice(1)) : x
      )
    : { ...obj, [next]: deleteByPath(obj[next], path.slice(1)) }
}
